import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import { Image } from '@miro-site/ui-design-system';
import styles from './nav-bar.module.scss';
import { HeaderMenuButton } from '../header-menu-button';
import classNames from 'classnames';
import { useHeaderData } from '../../hooks/use-header-data';
import { HeaderStateContext } from '../../context/header-state-context';
import { sortItemsIntoColumns } from './helpers/sort-items-into-columns';
import { getNavBarAnimationDelay } from './helpers/get-nav-bar-animation-delay';
import { WhatsNewLink } from '../whats-new/whats-new-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IMAGE_WIDTH = 44;
var IMAGE_HEIGHT = 44;
var currentColumnNumber = 0;
export var NavBarLinkList = function NavBarLinkList(_ref) {
  var items = _ref.items,
      numberOfItemsPerColumn = _ref.numberOfItemsPerColumn;
  var headerData = useHeaderData();

  var _useContext = useContext(HeaderStateContext),
      shouldAnimate = _useContext.shouldAnimate;

  return /*#__PURE__*/_jsx("ul", {
    className: "w-100",
    children: items.map(function (item, itemIndex) {
      var title = item.title,
          path = item.path;

      if (itemIndex % numberOfItemsPerColumn === 0) {
        currentColumnNumber++;
      }

      return /*#__PURE__*/_jsx("li", {
        className: classNames(styles.subMenuItem, _defineProperty({}, styles.animatedSubMenuItem, shouldAnimate)),
        style: {
          '--animation-delay': getNavBarAnimationDelay(currentColumnNumber, itemIndex)
        },
        children: /*#__PURE__*/_jsx("a", {
          className: classNames('btn btn-sm btn-link btn-fluid text-black', {
            active: (headerData === null || headerData === void 0 ? void 0 : headerData.currentPath) === path
          }),
          href: path,
          children: /*#__PURE__*/_jsxs("div", {
            className: "d-flex gap-200",
            children: [item.image && /*#__PURE__*/_jsx("div", {
              style: {
                width: "".concat(IMAGE_WIDTH, "px"),
                height: "".concat(IMAGE_HEIGHT, "px")
              },
              className: "rounded-50 border border-image-idle overflow-hidden",
              children: /*#__PURE__*/_jsx(Image, {
                className: "align-self-center",
                image: _objectSpread(_objectSpread({}, item.image), {}, {
                  width: IMAGE_WIDTH,
                  height: IMAGE_HEIGHT
                })
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "align-self-center",
              children: title.trim()
            })]
          })
        })
      }, "".concat(title, "-").concat(path));
    })
  });
};

var NavBarWhatsNewSection = function NavBarWhatsNewSection(_ref2) {
  var _classNames2;

  var numberOfItemsPerColumn = _ref2.numberOfItemsPerColumn;
  var headerData = useHeaderData();

  var _useContext2 = useContext(HeaderStateContext),
      shouldAnimate = _useContext2.shouldAnimate;

  if (!(headerData !== null && headerData !== void 0 && headerData.whatsNew)) {
    return null;
  }

  var whatsNew = headerData.whatsNew;
  var title = whatsNew.title,
      items = whatsNew.items;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('d-flex flex-column ps-400', (_classNames2 = {}, _defineProperty(_classNames2, styles.leftBorder, !shouldAnimate), _defineProperty(_classNames2, styles.animatedLeftBorder, shouldAnimate), _classNames2)),
    children: [/*#__PURE__*/_jsx("h2", {
      className: classNames('category mb-100 text-secondary', _defineProperty({}, styles.animatedSubMenuItem, shouldAnimate)),
      style: {
        '--animation-delay': getNavBarAnimationDelay(currentColumnNumber, 0)
      },
      children: title.trim()
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-column align-items-center d-flex justify-content-between ms-n100 h-100",
      children: [/*#__PURE__*/_jsx(NavBarLinkList, {
        items: items,
        numberOfItemsPerColumn: numberOfItemsPerColumn
      }), /*#__PURE__*/_jsx(WhatsNewLink, {
        className: classNames('ms-100 pt-100 align-self-start', _defineProperty({}, styles.animatedSubMenuItem, shouldAnimate)),
        link: whatsNew === null || whatsNew === void 0 ? void 0 : whatsNew.showAllLink,
        style: {
          '--animation-delay': getNavBarAnimationDelay(currentColumnNumber, items.length + 1)
        }
      })]
    })]
  });
};

export var NavBarItemWithSubMenu = function NavBarItemWithSubMenu(props) {
  var _classNames5;

  var _useContext3 = useContext(HeaderStateContext),
      activeItem = _useContext3.activeItem,
      selectItem = _useContext3.selectItem,
      shouldAnimate = _useContext3.shouldAnimate;

  var numberOfItemsPerColumn = props.numberOfItemsPerColumn,
      _props$showWhatsNew = props.showWhatsNew,
      showWhatsNew = _props$showWhatsNew === void 0 ? false : _props$showWhatsNew;

  var _ref3 = props.item || {},
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? '' : _ref3$title,
      _ref3$groups = _ref3.groups,
      groups = _ref3$groups === void 0 ? [] : _ref3$groups;

  var hasSubMenu = !!groups.length;
  var isActive = activeItem === title;
  currentColumnNumber = 0;
  return /*#__PURE__*/_jsxs("li", {
    className: "".concat(styles.navBarItem, " align-self-xl-center"),
    role: "menuitem",
    children: [/*#__PURE__*/_jsx(HeaderMenuButton, {
      hasSubMenu: hasSubMenu,
      isActive: isActive,
      onClick: function onClick() {
        selectItem(isActive ? '' : title);
      },
      onMouseEnter: function onMouseEnter() {
        selectItem(title);
      },
      onMouseLeave: function onMouseLeave() {
        selectItem();
      },
      title: "".concat(title).trim()
    }), hasSubMenu && /*#__PURE__*/_jsx("nav", {
      className: classNames('position-absolute py-xl-300 my-n150 my-xl-0 ms-n400', {
        'd-none': !isActive,
        'd-flex': isActive
      }),
      id: "product-navigation",
      "aria-hidden": "true",
      children: /*#__PURE__*/_jsxs("div", {
        className: classNames(styles.navBarSubMenu, 'd-flex position-relative gap-300 p-400'),
        children: [/*#__PURE__*/_jsx("div", {
          className: classNames('position-absolute shadow-100 bg-white rounded-150', (_classNames5 = {}, _defineProperty(_classNames5, styles.subMenuBackground, !shouldAnimate), _defineProperty(_classNames5, styles.animatedSubMenuBackground, shouldAnimate), _classNames5))
        }), groups.map(function (_ref4) {
          var title = _ref4.title,
              items = _ref4.items;
          var sortedItems = sortItemsIntoColumns(items, numberOfItemsPerColumn);
          return /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("h2", {
              className: classNames('category mb-100 text-secondary', _defineProperty({}, styles.animatedSubMenuItem, shouldAnimate)),
              style: {
                '--animation-delay': getNavBarAnimationDelay(currentColumnNumber, 0)
              },
              children: title.trim()
            }), /*#__PURE__*/_jsx("div", {
              className: "d-flex gap-400 ms-n100 mb-n150",
              children: sortedItems === null || sortedItems === void 0 ? void 0 : sortedItems.map(function (items) {
                return /*#__PURE__*/_jsx(NavBarLinkList, {
                  items: items,
                  numberOfItemsPerColumn: numberOfItemsPerColumn
                }, JSON.stringify(items));
              })
            })]
          }, title);
        }), showWhatsNew && /*#__PURE__*/_jsx(NavBarWhatsNewSection, {
          numberOfItemsPerColumn: numberOfItemsPerColumn
        })]
      })
    })]
  });
};